var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTennessee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M275.501,98.947l-5.813,3.197h-5.522l-179.898,18.89v5.814l-45.919,2.689l-0.904-0.308l-1.785,8.641l-2.588,12.528 c0,0-4.362,16.275-4.362,17.729c0,1.451-8.427,1.164-7.992,2.325c0.436,1.162,3.052,13.658,3.052,13.658l-6.102,4.942l68.588-4.942 l59.069-4.142l20.974-1.825l9.665-1.398l29.497-4.268c0,0,0.58-6.977,1.16-8.719c0.583-1.745,6.686-2.327,6.686-2.327 s0.583-5.521,4.069-9.3c3.487-3.776,11.915-3.776,15.694-8.718c3.778-4.94,11.335-6.103,11.335-6.103l0.87-5.157l5.522-5.982 l2.325-2.522l0.644,2.089l3.43-0.5c2.031-1.549,4.543-3.52,5.518-4.494c1.742-1.742,7.557-0.872,7.557-0.872 c2.906-7.555,8.719-10.462,8.719-10.462V98.947H275.501z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennessee);
export default __webpack_public_path__ + "static/media/tennessee.64c8cbb3203a2cfcb125c5e03ba3de8f.svg";
export { ForwardRef as ReactComponent };